class BehaviourStyle {
  static responsiveStyle(behaviourObj: any) {
    return {}
  }
}

export default BehaviourStyle